import { DatasetActions } from '@mode/dataset/contract';
import { LegacyAppStateStoreService, ofType } from '@mode/legacy/util-domain';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Actions } from '~/actions';
import { removeReportFromList } from '~/actions/home-actions';

export class HomeEffects {
  static $inject = ['actions$', 'StoreService'];

  constructor(
    private actions$: Observable<Actions>,
    private reduxStore: LegacyAppStateStoreService
  ) {
    this.actions$
      .pipe(
        ofType(DatasetActions.deleteFromCollectionView),
        map((action) => this.reduxStore.dispatch(removeReportFromList(action.token)))
      )
      .subscribe();
  }
}
